import { FormerMemberBankingTaxForms } from '../../../../former-member/components/FormerMemberBankingTaxForms';

export default function FormerMemberBankingTaxFormsPage() {
    return <FormerMemberBankingTaxForms />;
}
